// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__sDkia","img1container":"Home_img1container__3-Yh2","img1":"Home_img1__1q-hC","img1content":"Home_img1content__12v4g"};